import { render, staticRenderFns } from "./VFormDatePicker.vue?vue&type=template&id=1b65c018&"
import script from "./VFormDatePicker.vue?vue&type=script&lang=js&"
export * from "./VFormDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports